$(document).ready(function(){
  $( document ).on( 'click', '.modal__exit', function() {
    $('.kv-video').trigger('pause');
  });
});